import React from 'react';
import './Header.css';

const Header: React.FC = () => {
  return (
    <div className="header">
      <h1 className="header-title">무엇이든 골라드림</h1>
      <p className="header-subtitle">선택장애를 위한 무작위 추천 서비스</p>
    </div>
  );
};

export default Header;